<div class="google-places-autocomplete" [class]="className" (document:click)="handleClickOutside($event)" role="combobox" aria-autocomplete="list"
  [attr.aria-expanded]="showSuggestions" aria-controls="google-places-listbox" aria-haspopup="listbox" [attr.aria-label]="placeholder" [attr.aria-describedby]="showSuggestions ? 'suggestion-count' : null">
  <ion-searchbar #input type="text" mode="md" data-cy="searchArea" [(ngModel)]="inputValue"
    (ionInput)="handleInputChange($event.detail.value!)" (click)="handleInputClick($event)" [placeholder]="placeholder"
    [class]="'google-places-input ' + inputClassName" [debounce]="500"></ion-searchbar>
  
  <div id="suggestion-count" class="sr-only" *ngIf="showSuggestions && suggestions.length">
    {{ suggestions.length }} suggestions available
  </div>

  <div #suggestionsElement *ngIf="showSuggestions && suggestions.length > 0"
    [class]="'google-places-suggestions ' + suggestionsClassName" id="google-places-listbox" role="listbox">
    <ng-container *ngFor="let suggestion of suggestions; let i = index">
      <div class="suggestion-item" data-cy="suggestionItem"
        (click)="handleSuggestionClick(suggestion?.placePrediction?.placeId || '')" role="option" tabindex="0" 
        [attr.aria-setsize]="suggestions.length"
        [attr.aria-posinset]="i + 1" [attr.aria-label]="suggestion?.placePrediction?.mainText + ', ' + suggestion?.placePrediction?.secondaryText + '. ' + (i + 1) + ' of ' + suggestions.length">
        <div class="icon">
          <ion-icon aria-hidden="true" name="location-outline"></ion-icon>
        </div>
        <div class="text">
          <div class="main-text">{{ suggestion?.placePrediction?.mainText }}</div>
          <div class="secondary-text">{{ suggestion?.placePrediction?.secondaryText }}</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>